import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { LoadingButton } from "@mui/lab";
import { useTheme, Button, darken, alpha, Box } from "@mui/material";
import { useThemeColor } from "../../../themes/hooks/useThemeColor.es.js";
const EzButtonMui = forwardRef(
  ({ ariaHidden, ariaLabel, children, color, fontSize, loading, variant, ...props }, ref) => {
    var _a, _b;
    const theme = useTheme();
    const isCommonColor = (color == null ? void 0 : color.startsWith("common.")) || color === "destructive";
    const themeColor = useThemeColor(color === "destructive" ? "common.red110" : color);
    const ButtonComponent = loading ? LoadingButton : Button;
    const baseVariant = (btnVariant) => {
      switch (btnVariant) {
        case "filled":
          return "contained";
        case "inline":
          return "text";
        default:
          return btnVariant;
      }
    };
    return /* @__PURE__ */ jsx(
      ButtonComponent,
      {
        ref,
        "aria-hidden": ariaHidden,
        "aria-label": ariaLabel,
        classes: {
          root: `EzButton EzButton-${variant}`,
          startIcon: "EzButton-startIcon",
          endIcon: "EzButton-endIcon",
          disabled: "EzButton-disabled"
        },
        color: isCommonColor ? void 0 : color,
        disableElevation: true,
        loading: loading ? true : void 0,
        sx: {
          bgcolor: isCommonColor && variant === "filled" ? themeColor : void 0,
          borderColor: isCommonColor && variant === "outlined" ? alpha(themeColor, 0.5) : void 0,
          color: isCommonColor && variant !== "filled" ? themeColor : void 0,
          fontSize: fontSize === "inherit" ? fontSize : ((_b = (_a = theme.typography) == null ? void 0 : _a.font) == null ? void 0 : _b.size[fontSize]) || void 0,
          padding: variant === "inline" ? 0 : void 0,
          verticalAlign: variant === "inline" ? "inherit" : void 0,
          "&:hover, &:active": {
            bgcolor: variant === "filled" ? darken(themeColor, 0.2) : alpha(themeColor, 0.1),
            borderColor: variant !== "text" ? themeColor : void 0
          }
        },
        variant: baseVariant(variant),
        ...props,
        children: /* @__PURE__ */ jsx(Box, { whiteSpace: "nowrap", children })
      }
    );
  }
);
EzButtonMui.displayName = "EzButtonMui";
export {
  EzButtonMui as default
};
//# sourceMappingURL=EzButtonMui.es.js.map
